// Full IANA timezone list, sourced once from the runtime (Intl.supportedValuesOf).
// Each option carries a GMT-offset label and searchable text so a single Select
// can cover every zone without a hand-maintained list.

const offsetLabel = (tz) => {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: "shortOffset",
    }).formatToParts(new Date());
    return parts.find((p) => p.type === "timeZoneName")?.value || "";
  } catch {
    return "";
  }
};

const FALLBACK = [
  "UTC", "Europe/Kyiv", "Europe/London", "Europe/Moscow", "Europe/Berlin",
  "America/New_York", "America/Chicago", "America/Los_Angeles",
  "Asia/Dubai", "Asia/Singapore", "Asia/Tokyo",
];

const zones =
  typeof Intl.supportedValuesOf === "function"
    ? Intl.supportedValuesOf("timeZone")
    : FALLBACK;

// Ensure UTC is always first / present.
const ordered = ["UTC", ...zones.filter((z) => z !== "UTC")];

export const TIMEZONES = ordered.map((tz) => {
  const off = offsetLabel(tz);
  return {
    value: tz,
    label: off ? `${tz} (${off})` : tz,
    search: tz.replace(/[_/]/g, " "),
  };
});

// Options including an "auto — device timezone" entry for personal profiles.
export const TIMEZONES_WITH_AUTO = [
  { value: "", label: "Auto — device timezone", search: "auto device browser detected default" },
  ...TIMEZONES,
];
